import { useEffect, useState } from 'react'

/** Thin bar under the header while the device has no connection, so a blank list is never a mystery. */
export default function PwaOfflineNotice() {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  )

  useEffect(() => {
    const goOnline = () => setOnline(true)
    const goOffline = () => setOnline(false)
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  if (online) return null

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-[calc(56px+env(safe-area-inset-top,0px))] z-40 border-b border-m1-amber/35 bg-[#2a2113] px-4 py-2 text-center text-[13px] text-m1-ink-soft"
    >
      You are offline. Cards and orders will refresh when your connection returns.
    </div>
  )
}
